export const SCHEDULING_MIDDLEWARE_ENDPOINTS = {
  GET_SERVICE_COUNT: 'evaluation/{{externalId}}/count',
  GET_REASONS: 'evaluation/reasons',
  EVALUATE: 'evaluation/evaluate',
}
